import { render, staticRenderFns } from "./VolumeButton.vue?vue&type=template&id=528b472e&scoped=true&"
import script from "./VolumeButton.vue?vue&type=script&lang=js&"
export * from "./VolumeButton.vue?vue&type=script&lang=js&"
import style0 from "./VolumeButton.vue?vue&type=style&index=0&id=528b472e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b472e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VMenu,VSlider})
